<template>
  <div class="background">
    <div class="cardLogin">
      <h1 class="title">Soprachev dashboard</h1>
      <form @submit.prevent="submitHandler">
        <div class="inputs">
          <input class="card-input trElement" type="text" placeholder="Login" v-model.trim="login" />
          <hr class="hr" />
          <div class="password-line">
            <input
              class="card-input trElement"
              type="password"
              placeholder="Password"
              v-model.trim="password"
            />
            <div class="d-flex align-items-center" v-if="logining">
              <b-spinner class="ml-auto"></b-spinner>
            </div>
            <button class="trElement" type="submit" v-else-if="password && login">
              <b-icon icon="arrow-right-circle" scale="1.4"></b-icon>
            </button>
          </div>
        </div>
      </form>
      <p class="errorLogin" v-if="hasError">Неверное имя пользователя или пароль</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    login: "",
    password: "",
    logining: false,
    errorMessage: "",
  }),
  computed: {
    hasError() {
      return this.errorMessage !== "";
    },
  },
  methods: {
    async submitHandler() {
      this.logining = true;
      const formData = {
        login: this.login,
        password: this.password,
        name: navigator.vendor,
      };

      this.$store
        .dispatch("login", formData)
        .then((success) => {
          this.$router.push("/profile");
        })
        .catch((error) => {
          this.errorMessage = error.response;
          this.password = "";
        })
        .finally(() => {
          this.logining = false;
        });

      // try {
      //   await this.$store.dispatch("login", formData);
      //   this.$router.push("/");
      // } catch (e) {}
    },
  },
};
</script>


<style scoped>
.errorLogin {
  margin-top: 5px;
  color: rgb(175, 0, 0);
  font-weight: 300;
  font-size: 12px;
}

.ml-auto {
  width: 22px;
  height: 22px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  margin: 0 3px 0 0;
}

.title {
  margin: 0 auto 13px;
  color: white;
  font-size: 21px;
  font-weight: 200;
}

.password-line {
  display: flex;
  align-items: center;
}

.background {
  display: flex;
  width: 100%;
  height: 100vh;
  background: rgb(110, 143, 160);
  background: linear-gradient(
    0deg,
    rgba(110, 143, 160, 1) 0%,
    rgba(161, 188, 203, 1) 50%,
    rgba(110, 143, 160, 1) 100%
  );
}

.inputs {
  min-width: 300px;
  background-color: white;
  border-radius: 10px;
  padding: 0 10px;
}

.cardLogin {
  max-width: 320px;
  margin: auto;
  margin-top: 10rem;
  text-align: center;
}

.hr {
  margin: 0;
}

.card-input {
  display: block;
  width: 100%;
  min-height: 2rem;
}

.centering {
  display: flex;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100vh;
}
</style>